// YdmTab.js — YDM (Yield Distribution Model) simulator tab for the Integrated Simulator.
// Allows users to explore curve shapes and apply Y₀/Y_T/Y₁₀₀/Speed to any market.

import { useState, useCallback } from 'react';
import { YdmContent } from '../../pages/YdmSimulator';
import { useSession, useSessionDispatch } from './SessionContext';
import COLORS from '../../lib/colors';

export default function YdmTab() {
  const { state } = useSession();
  const dispatch = useSessionDispatch();
  const marketNames = Object.keys(state.markets);

  const [targetMarket, setTargetMarket] = useState('');
  const [appliedMsg, setAppliedMsg] = useState(null);

  const effectiveTarget = targetMarket || marketNames[0] || '';

  const handleApplyCurve = useCallback(({ y0, yT, y100, speed }) => {
    if (!effectiveTarget) return;
    dispatch({ type: 'UPDATE_MARKET', name: effectiveTarget, patch: { ydm: { version: 'V2', y0, yT, y100, speed } } });
    setAppliedMsg(`Applied to ${effectiveTarget}: Y₀=${(y0*100).toFixed(1)}% · Y_T=${(yT*100).toFixed(1)}% · Y₁₀₀=${(y100*100).toFixed(1)}% · Speed=${speed}/yr`);
    setTimeout(() => setAppliedMsg(null), 4000);
  }, [effectiveTarget, dispatch]);

  return (
    <div style={{ padding: '24px', fontFamily: "'IBM Plex Sans', 'Helvetica Neue', sans-serif" }}>
      {marketNames.length > 0 && (
        <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', background: COLORS.surface, border: `1px solid ${COLORS.borderLight}`, borderRadius: 4 }}>
          <span style={{ fontFamily: "'Fragment Mono', monospace", fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase', color: COLORS.textSecondary, flexShrink: 0 }}>Apply Playground curve to:</span>
          <select
            value={effectiveTarget}
            onChange={(e) => setTargetMarket(e.target.value)}
            style={{ fontFamily: "'Fragment Mono', monospace", fontSize: 12, color: COLORS.ink, background: COLORS.bg, border: `1px solid ${COLORS.borderLight}`, borderRadius: 2, padding: '4px 8px', outline: 'none', cursor: 'pointer' }}
          >
            {marketNames.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
          {appliedMsg
            ? <span style={{ fontFamily: "'Fragment Mono', monospace", fontSize: 11, color: COLORS.positive }}>{appliedMsg}</span>
            : <span style={{ fontFamily: "'Fragment Mono', monospace", fontSize: 11, color: COLORS.textTertiary }}>Use the Playground tab below, then click → Apply to Selected Market</span>
          }
        </div>
      )}
      <YdmContent onApplyCurve={marketNames.length > 0 ? handleApplyCurve : undefined} markets={state.markets} />
    </div>
  );
}
